import React, { useState } from 'react'

import { AiFeature } from '../../../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../../../models/AiResult'
import { Tooltip } from '../../../../../../../../components/Tooltip/Tooltip'
import { Button } from '../../../../../../../../components/Button/Button'
import { AddResultToEmailProviderModal } from '../../../../../../../../views/MeetingSummary/EmailProvider/AddResultToEmailProviderModal'
import { selectCurrentUser } from '../../../../../../../../store/meetingSummary/user'
import { useAppSelector } from '../../../../../../../../store/hooks'

import './HeaderResultEmailButton.scss'
import { getMailIntegrationServiceLabel, IntegrationServiceId } from '../../../../../../../../common/integrations'
import { IntegrationIcon } from '../../../../../../../../components/IntegrationIcon'
import { TrackEvent, useTracking } from '../../../../../common/tracking'
import { getAIFeatureAndResultTrackingDetails } from '../../../../../tracking'

export interface HeaderResultEmailButtonProps {
  aiFeature: AiFeature
  aiResult: AiResult
  serviceId: string
}

export const HeaderResultEmailButton: React.FC<HeaderResultEmailButtonProps> = ({ aiFeature, aiResult, serviceId }) => {
  const { tracked } = useTracking()

  const currentUser = useAppSelector(selectCurrentUser)
  const { integrations: currentUserIntegrations } = currentUser ?? {}

  const [showModal, setShowModal] = useState<boolean>(false)

  const userHasIntegration = currentUserIntegrations?.some((e) => e.serviceId === serviceId)

  const _handleSaveToEmailProviderClicked = () => {
    setShowModal(true)
  }

  const handleSaveToEmailProviderClicked = tracked(_handleSaveToEmailProviderClicked, {
    eventName: TrackEvent.SAVE_RESULTS_TO_EMAIL_PROVIDER_CLICKED,
    eventDetails: { connector: serviceId, ...getAIFeatureAndResultTrackingDetails(aiFeature, aiResult) },
  })

  if (!userHasIntegration) {
    return null
  }

  return (
    <div className='d-none d-md-flex'>
      {showModal && (
        <AddResultToEmailProviderModal aiFeature={aiFeature} aiResult={aiResult} show={showModal} onHide={() => setShowModal(false)} serviceId={serviceId} />
      )}
      <Tooltip className='paragraph-small' title={`Save to ${getMailIntegrationServiceLabel(serviceId)}`} placement='top' offset={[0, 10]}>
        <Button className='px-2' variant='header' onClick={handleSaveToEmailProviderClicked}>
          <IntegrationIcon serviceId={serviceId as IntegrationServiceId} className='email-icon' fill='var(--zocks-gray-900)' />
        </Button>
      </Tooltip>
    </div>
  )
}
